import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TabMenuModule } from 'primeng/tabmenu';
import { MenuItem } from 'primeng/api';

import { Router } from '@angular/router';
import { AppSettings } from '@shared/models/settings/app-settings';
import { SignalsService } from '@shared/services/signals/signals.service';

@Component({
  selector: 'app-tab-menu',
  standalone: true,
  imports: [
    TabMenuModule
  ],
  templateUrl: './tab-menu.component.html',
  styleUrl: './tab-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabMenuComponent implements OnInit {

  tabItems: MenuItem[] = [];
  activeItem?: MenuItem;
  appSettings?: AppSettings;
  activeIndex: number = 0;

  constructor(
    private signalService: SignalsService,
    private router: Router) { }
  

  ngOnInit(): void {
    this.tabItems = [
      {
        label: 'Table View',
        command: () => {
          this.router.navigate(['flights', 'flight-table'])
        },
        tabindex: '0'
      },
      {
        label: 'Calendar View',
        command: () => {
          this.router.navigate(['flights', 'flight-calendar'])
        },
        tabindex: '1'
      }
    ];


    const defaultItemIndex = this.signalService.defaultTabItem$();
    const to = sessionStorage.getItem('to') ? JSON.parse(sessionStorage.getItem('to')!) : null;

    if (to === 'flight-calendar') {
      this.activeItem = this.tabItems[1];
      this.router.navigate(['flights', 'flight-calendar'])
    }
    else if (to === 'flight-table') {
      this.activeItem = this.tabItems[0];
      this.router.navigate(['flights', 'flight-table'])
    }
    else {
      this.activeItem = this.tabItems[defaultItemIndex];
      if (defaultItemIndex === 1) {
        this.router.navigate(['flights', 'flight-calendar'])
      }
      else {
        this.router.navigate(['flights', 'flight-table'])
      }
    }
  }

  onActiveTabChange(event: MenuItem): void {
    this.activeItem = event;
  }

}
